import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import pdf from "../../Assets/yuvasreeResume.pdf";
import { AiOutlineDownload } from "react-icons/ai";
import { Document, Page, pdfjs } from "react-pdf";
import PageSEO from "../../utils/PageSEO";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import { useTranslation } from "../../i18n";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const PDF_MAX_WIDTH = 640;
const RESUME_FILENAME = "Yuvasree_Padmanabhan_Resume.pdf";

function getPdfDisplayWidth(viewportWidth) {
  const sidePadding = 24;

  if (viewportWidth >= 992) {
    return PDF_MAX_WIDTH;
  }
  if (viewportWidth >= 768) {
    return Math.min(560, viewportWidth - sidePadding * 2);
  }
  return Math.min(viewportWidth - sidePadding, 480);
}

function ResumeNew() {
  const { t } = useTranslation();
  const [width, setWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1200
  );

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const pdfWidth = getPdfDisplayWidth(width);

  const resumeStructuredData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://yuvasree.online/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Resume",
        "item": "https://yuvasree.online/resume"
      }
    ]
  };

  return (
    <div>
      <PageSEO
        title="Resume | Yuvasree Padmanabhan | Download CV"
        description="Download Yuvasree Padmanabhan's resume/CV featuring full stack development skills, automation engineering experience, certifications, education, and professional background."
        keywords="Yuvasree resume, CV, download, professional resume, automation engineer, software developer, education, certifications, technical skills"
        url="https://yuvasree.online/resume"
        structuredData={resumeStructuredData}
      />
      <Container fluid className="resume-section">
        <Particle />

        <Row className="resume">
          <div className="resume-pdf-wrapper">
            <div className="resume-pdf-frame">
              <Document file={pdf} className="resume-pdf-document">
                <Page
                  pageNumber={1}
                  width={pdfWidth}
                  renderTextLayer={false}
                  renderAnnotationLayer={false}
                />
              </Document>
            </div>
          </div>
        </Row>

        <Row className="resume-download-row">
          <Col xs="auto" className="text-center">
            <Button
              as="a"
              variant="primary"
              href={pdf}
              download={RESUME_FILENAME}
              className="resume-download-btn"
            >
              <AiOutlineDownload />
              &nbsp;{t("resume.downloadCv")}
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ResumeNew;
